var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    stroke: "inherit",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "M28.823 4.525c1.34-.843 1.4-1.434 1.884-3.029a12.633 12.633 0 0 1-4.115 1.658C25.412 1.829 23.726 1 21.864 1c-3.578 0-6.479 3.054-6.479 6.816 0 .536.058 1.056.167 1.554C10.167 9.087 5.394 6.372 2.2 2.247a7.07 7.07 0 0 0-.879 3.428c0 2.366 1.145 4.451 2.883 5.674a6.224 6.224 0 0 1-2.934-.852l-.001.085c0 3.303 2.234 6.057 5.198 6.684a6.19 6.19 0 0 1-2.927.117c.825 2.707 3.218 4.678 6.052 4.734C6.82 24.403 3.381 25.355 0 24.938 2.867 26.872 6.272 28 9.932 28c11.917 0 18.43-10.386 18.43-19.393 0-.297-.003-.588-.016-.883C29.61 6.764 31.132 5.87 32 4.501c-1.16.545-2.139.562-3.177.024z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c8375ba7a86be93d69869ed4380b3f63.svg";
export { ForwardRef as ReactComponent };